import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import {
  questionFindByIdQuery,
  questionSaveMutation,
} from '../../../shared/queries/QuestionDatabase';
import {
  changeLoadingTrue,
  changeLoadingFalse,
} from '../../../redux/actions/loadingActions';
import GraphQL from '../../../GraphQL';
import { showNotificationAutoDestroy } from '../../../shared/components/ShowNotification';
import SmartCard from '../../../shared/components/SmartCard';
import QuestionDatabaseForm from './Form';

const QuestionDatabaseFormHandler = (props) => {
  const { match, t, history, dispatch } = props;

  const [dto, setDto] = useState({ id: 0, active: true });
  const [formOn, setFormOn] = useState(false);

  function backClickHandler() {
    history.push('/minime/banco-questoes');
  }

  function showLoading() {
    dispatch(changeLoadingTrue());
  }

  function hideLoading() {
    dispatch(changeLoadingFalse());
  }

  function findById(id) {
    showLoading();
    const query = questionFindByIdQuery(id);
    GraphQL(query, {})
      .then((res) => {
        if (res.questionFindById) {
          setDto({
            ...res.questionFindById,
            type: {
              value: res.questionFindById.type,
              label: t(
                `question.type-description.${res.questionFindById.type}`
              ),
            },
          });
        } else {
          showNotificationAutoDestroy(
            'danger',
            t('notifications.error'),
            t('notifications.record-not-found')
          );
          backClickHandler();
        }
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('notifications.error'),
          t('notifications.find-record-error')
        );
      })
      .finally(() => {
        hideLoading();
      });
  }

  const handleSubmit = (values) => {
    const mutation = questionSaveMutation(values);
    showLoading();
    GraphQL(mutation, {})
      .then(() => {
        backClickHandler();
        showNotificationAutoDestroy(
          'success',
          t('success.title'),
          t('success.successfully-saved')
        );
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('notifications.error'),
          t('errors.error-to-save')
        );
      })
      .finally(() => {
        hideLoading();
      });
  };

  useEffect(() => {
    if (match.params.id && match.params.id > 0) {
      if (dto.id !== parseInt(match.params.id, 0)) {
        findById(match.params.id);
      } else {
        setFormOn(true);
      }
    } else {
      setFormOn(true);
    }
  }, [dto]);

  return (
    <SmartCard title={t('panels.banco-questoes')}>
      {formOn ? (
        <QuestionDatabaseForm
          backHandler={backClickHandler}
          onSubmit={handleSubmit}
          dto={dto}
        />
      ) : null}
    </SmartCard>
  );
};

QuestionDatabaseFormHandler.propTypes = {
  t: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  match: ReactRouterPropTypes.match.isRequired,
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(QuestionDatabaseFormHandler)
);
